/**
 *
 * @module bamIdentityClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef BamIdentityClientEndpoint
 * @type {Object}
 *
 * @property {String} identityLogin
 * @property {String} createIdentity
 * @property {String} changeEmail
 * @property {String} changePassword
 * @property {String} startPasswordReset
 * @property {String} resetPassword
 * @property {String} getIdentity
 * @property {String} updateAttributes
 * @property {String} otpRequest
 * @property {String} otpRedeem
 *
 */

/**
 *
 * @enum
 * @type {BamIdentityClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    identityLogin: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    createIdentity: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    changeEmail: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    changePassword: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    startPasswordReset: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    resetPassword: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    getIdentity: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    updateAttributes: null,
    /**
     *
     * @access public
     * @since 3.9.0
     * @type {String}
     *
     */
    check: null,
    /**
     *
     * @access public
     * @since 3.9.0
     * @type {String}
     *
     */
    otpRequest: null,
    /**
     *
     * @access public
     * @since 3.9.0
     * @type {String}
     *
     */
    otpRedeem: null

});



// WEBPACK FOOTER //
// ./src/services/identity/bam/bamIdentityClientEndpoint.js